document.addEventListener('DOMContentLoaded', () => {
  const swatchLabels = document.querySelectorAll('.swatch-label');
  const allowedColors = ['bronze', 'silver', 'gold', 'stripy', 'rainbow', 'redblue'];

  for (const swatchLabel of swatchLabels) {
    const variantTitle = swatchLabel.dataset.variantTitle.toLowerCase().replace(/\s+/g, '');

    if (allowedColors.includes(variantTitle)) {
      continue;
    }

    const swatchBall = swatchLabel.querySelector('.swatch-color-ball');

    if (CSS.supports('color', variantTitle)) {
      swatchLabel.classList.add('swatch-color');
      swatchBall.style.backgroundColor = variantTitle;
    } else {
      console.log('CSS Color "' + variantTitle + '" is not supported.');
      swatchLabel.classList.remove('swatch-color');
      swatchBall.textContent = variantTitle;
      swatchBall.classList.remove('swatch-color-ball');

      if (!swatchLabel.classList.contains('swatch-more')) {
        swatchBall.classList.add('swatch-name');
      }
    }
  }
});
